module.exports = __webpack_public_path__ + "static/media/social-media-users.6d2530db.png";